import React, { FC } from 'react';
import classnames from 'classnames';
import ReCAPTCHA from 'react-google-recaptcha';
import { TextField } from '@src/components/TextField';
import Checkbox from '@src/components/Checkbox';
import { GOOGLE_CAPTCHA_SITE_KEY } from '@src/constants';
import { FormKey } from '../enums/formKey.enum';
import { FormType } from '../enums/formType.enum';
import { StepTwoProps } from './props';
import './styles.scss';

const FORM = [
  {
    key: FormKey.POSITION_TITLE,
    label: 'Your position title',
    placeholder: 'Your position title',
    type: FormType.INPUT,
  },
  {
    key: FormKey.PHONE_NUMBER,
    label: 'Phone number',
    placeholder: 'Phone number',
    type: FormType.INPUT,
  },
  {
    key: FormKey.COMPANY_SIZE,
    label: 'Company size',
    placeholder: 'Company size',
    type: FormType.SELECT,
  },
  {
    key: FormKey.COUNTRY,
    label: 'Country',
    placeholder: 'Country',
    type: FormType.SELECT,
  },
  {
    key: FormKey.SOURCE,
    label: 'How did you hear about MeetFrank',
    placeholder: 'How did you hear about MeetFrank',
    type: FormType.SELECT,
  },
];

const marketingChannels = [
  {
    id: 'facebook_instagram_ad',
    name: 'Facebook/Instagram ad',
  },
  {
    id: 'recommendation',
    name: 'Recommended by a friend or colleague',
  },
  {
    id: 'received_applicants',
    name: "We've received applicants from MeetFrank",
  },
  {
    id: 'used_as_candidate',
    name: "I've used MeetFrank as a candidate",
  },
  {
    id: 'linkedin_ad',
    name: 'LinkedIn ad',
  },
  {
    id: 'google_search',
    name: 'Google search',
  },
];

export const StepTwo: FC<StepTwoProps> = ({ formData, companySizes, countries, onChange }) => {
  const getOptions = (key: FormKey) => {
    switch (key) {
      case FormKey.COMPANY_SIZE:
        return { options: companySizes, placeholder: 'Company size' };
      case FormKey.COUNTRY:
        return { options: countries, placeholder: 'Country' };
      case FormKey.SOURCE:
        return { options: marketingChannels, placeholder: 'How did you hear about MeetFrank' };
      default:
        return { options: [] };
    }
  };

  return (
    <div className="register-step-two fade-in">
      <div className="register-step-two__header">
        <h4>You're almost there...</h4>
        <p>Please fill in additional information</p>
      </div>
      {FORM.map(({ key, label, placeholder, type }) => {
        if (type === FormType.INPUT) {
          return (
            <TextField
              defaultValue={formData[key]?.value || ''}
              fullWidth={true}
              key={key}
              label={label}
              message={formData[key]?.error || ''}
              messageType={!!formData[key]?.error && 'error'}
              onChange={value => onChange(key, value)}
              placeholder={placeholder}
              wrapperClassName="register-step-two__input"
            />
          );
        } else if (type === FormType.SELECT) {
          const data = getOptions(key);

          return (
            <div
              className={classnames(
                'register-step-two__select-wrapper',
                formData[key]?.error && 'register-step-two__select-wrapper--error',
              )}
              key={key}
            >
              <select onChange={event => onChange(key, event.target.value.trim())}>
                <option disabled selected>
                  {data.placeholder}
                </option>
                {data.options.map(option => (
                  <option key={option?.id} value={option?.id}>
                    {option?.name}
                  </option>
                ))}
              </select>
              {formData[key]?.error ? (
                <p
                  className={classnames(
                    'register-step-two__select-message',
                    formData[key]?.error && 'register-step-two__select-message--error',
                  )}
                >
                  {formData[key]?.error}
                </p>
              ) : null}
            </div>
          );
        } else {
          return null;
        }
      })}

      <div className="register-step-two__terms-wrapper">
        <Checkbox
          invalid={!!formData[FormKey.TERMS_OF_USE]?.error}
          label={
            <span>
              I accept the{' '}
              <a className="register-step-two__terms-link" href="/terms" target="_">
                terms of use
              </a>
            </span>
          }
          onChange={value => onChange(FormKey.TERMS_OF_USE, value)}
          value={!!formData[FormKey.TERMS_OF_USE]?.value}
          wrapperClassName="fast-track-modal-input-checkbox"
        />
      </div>

      <div className="register-step-two__captcha-wrapper">
        <ReCAPTCHA onChange={value => onChange(FormKey.CAPTCHA, value)} sitekey={GOOGLE_CAPTCHA_SITE_KEY} />
      </div>
    </div>
  );
};
